module.exports = __webpack_public_path__ + "static/media/costco.295dc6db.png";